import SectionModel from '../section/section-model';
import OwnerModel from '../owner/owner-model';
import QuizanswerModel from '../quizanswer/quizanswer-model';

export default class QuizresultModel {
    id: number;
    name: string;
    description: string;
    status: string;
    owner: any;
    ownerCaption: string;
    title: string;
    content: string;
    seq: number;
    valuemin: number;
    valuemax: number;
    scale: number;
    factor: number;
    tag: string;
    quizanswer: any;
    quizanswerValue: number;
    quizresult: any;
    quizresultTitle: string;
    section: any;

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        let owner = datarow.owner?.data? new OwnerModel(datarow.owner?.data) : datarow.owner;
        this.owner = owner?.id;
        this.ownerCaption = owner?.name;
        this.title = datarow.title;
        this.content = datarow.content;
        this.seq = datarow.seq;
        this.valuemin = datarow.valuemin;
        this.valuemax = datarow.valuemax;
        this.scale = datarow.scale;
        this.factor = datarow.factor<=0? 1: datarow.factor;
        this.tag = datarow.tag;
        this.quizanswer = datarow.quizanswer?.data?.map((d: any) => new QuizanswerModel(d));
        this.quizanswerValue = 
            this.quizanswer?.reduce((r: any, d: any) => {
                const id = d.quizquestion?.data?.id;
                const idx = r.findIndex((d2: any) => d2.id === id);
                if(d.quizquestion?.data?.attributes.type === 'multiplematch') {
                    if (idx < 0) r.push( {id: id, value: d.value })
                    else r[idx].value = r[idx].value===0 || d.value===0? 0 : 1;
                }
                else if (d.value > 0) r.push( {id: id, value: d.value });
                return r;
            }, []).reduce((v: number, d: any) => { return v + d.value; }, 0) || 0;
        this.quizanswerValue = Math.round(this.quizanswerValue / this.factor);
        this.quizresult = datarow.quizresult?.data?.map((d: any) => new QuizresultModel(d)).
            filter((d: any) => this.quizanswerValue >= d.valuemin && this.quizanswerValue <= d.valuemax);
        this.quizresultTitle = this.quizresult?.[0]?.title;
        let section = this.quizanswer?.[0]?.quizquestion?.data?.attributes.section?.data;
        this.section = section? new SectionModel(section) : datarow.section;
        
    } 

    public static endPoint: string = 'quiz-results' 
    public static endPointFilterList = (eventName?: string, parentId?: number) => {
        const owner = OwnerModel.getOwner();
        return (
            eventName?
            ('?populate[quizresult][sort]=seq' +
            '&populate[quizanswer][sort]=id' +
            '&populate[quizanswer][populate][eventquiz][sort]=id' +
            '&populate[quizanswer][filters][eventquiz][name][$startsWith]=' + eventName +                                
            '&filters[quizanswer][eventquiz][name][$startsWith]=' + eventName
            )
            : ('?populate=*&sort=name' +
            '&filters[owner]=' + owner +
            '&filters[parent]' + (parentId? '=' + parentId : '[id][$null]=true')
            )
        );
    } 
    public static endPointFilterList2 = (eventName?: string, sectionName?: string) => {
        return ('?sort=seq' +
                '&populate[quizresult][sort]=seq' +
                '&populate[quizanswer][populate][quizquestion][populate]=section' +
                '&filters[parent][id][$null]=true' +                                           
                (eventName? '&populate[quizanswer][filters][eventquiz][name][$startsWith]=' + eventName : '') +
                (sectionName? '&filters[name][$contains]=' + sectionName : '')
        )
    }
    public static url: string = '/quizresult';
    public static caption: string = 'Quiz Result';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        owner: +OwnerModel.getOwner(),
        ownerCaption: OwnerModel.getOwnerCaption(),   
        title: '',
        content: '',
        seq: 0,
        valuemin: 0,
        valuemax: 0,
        scale: 0,
        factor: 1,
        tag: '',
        quizanswer: [],
        quizanswerValue: 0,  
        quizresult: [],
        quizresultTitle: '',
        section: null,
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
    ]
    
    public static columnResult = [
        { name: 'name', caption: 'Tahap', type: 'caption' },
        { name: 'quizanswerValue', caption: 'Nilai', type: 'number' },
        { name: 'quizresultTitle', caption: 'Kategori' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
    
}